import { IMatchRunResults } from "@nkr/models/matching";
import { RowWrapper } from '../styles';

interface IProps {
    results: IMatchRunResults,
    isLoopRun: boolean
}

const RunStatistics = (props: IProps) => {
    if (props.results == null)
        return null;

    const { nddOneWayCount, ddOneWaysConfigured, totalOneWays, chainStartCount } = props.results;

    return (
        <>
            <RowWrapper className='row row-header'>
                <div className='col-xs-6 header'>
                    Run Statistics
                </div>
                <div className='col-xs-6 header'>
                    Node Count
                </div>
            </RowWrapper>

            <div className='row-tbody'>
                {props.isLoopRun == false && (
                    <>
                        <RowWrapper className='row'>
                            <div className='col-xs-6 col-left'>NDD One-ways in Results</div>
                            <div className='col-xs-6 col-right'>{nddOneWayCount}</div>
                        </RowWrapper>

                        <RowWrapper className='row'>
                            <div className='col-xs-6 col-left'>DD One-ways Configured</div>
                            <div className='col-xs-6 col-right'>{ddOneWaysConfigured}</div>
                        </RowWrapper>
                    </>
                )}
                
                <RowWrapper className='row'>
                    <div className='col-xs-6 col-left'>Total One-ways</div>
                    <div className='col-xs-6 col-right'>{totalOneWays}</div>
                </RowWrapper>
                <RowWrapper className='row'>
                    <div className='col-xs-6 col-left'>{props.isLoopRun ? 'DD\'s Selected' : 'NDD\'s Selected'}</div>
                    <div className='col-xs-6 col-right'>{chainStartCount}</div>
                </RowWrapper>
            </div>
        </>
    );
}

export default RunStatistics;